import config from "config";
import store from "store";
import { compareStrings } from "util/string";
import BaseAuthDriver from "./BaseAuthDriver";

class StaticConfigAuthDriver extends BaseAuthDriver {
  static init() {
    return new StaticConfigAuthDriver();
  }

  getCurrentUser() {
    return new Promise((resolve, reject) => {
      const authData = store.get("auth");

      if (authData && authData.user) {
        resolve(store.get("auth").user);
      } else {
        reject("No user currently logged in");
      }
    });
  }

  isCurrentUserAuthorizedTo(action) {
    return new Promise((resolve, reject) => {
      if (this.isUserLoggedIn()) {
        resolve(true);
      } else {
        reject("User is not authorized");
      }
    });
  }

  isUserLoggedIn() {
    return new Promise((resolve, reject) => {
      this.getCurrentUser()
        .then((userData) => {
          resolve(!!userData);
        })
        .catch((error) => {
          console.debug(error);
          resolve(false);
        });
    });
  }

  attemptLogin(creds) {
    return new Promise((resolve, reject) => {
      const username = creds.username;
      const password = creds.password;
      let authData;

      const validLogin =
        compareStrings([config("superadmin.username"), username], true, true) &&
        compareStrings([config("superadmin.password"), password]);

      if (validLogin) {
        authData = Object.assign({}, store.get("auth"), {
          user: {
            username,
            name: username,
            type: "superadmin"
          }
        });

        store.set("auth", authData);
        resolve(authData);
      } else {
        reject("Incorrect credentials");
      }
    });
  }

  logout() {
    return new Promise((resolve, reject) => {
      store.remove("auth");
      resolve(true);
    });
  }
}

export default StaticConfigAuthDriver;
